
	<!-- TemplateBeginEditable name="hero" -->
	<div class="dcf-hero dcf-hero-default">
		<!-- TemplateEndEditable -->
		<div class="dcf-hero-group-1">
			<div class="dcf-breadcrumbs-wrapper">
				<nav class="dcf-breadcrumbs" id="dcf-breadcrumbs" role="navigation" aria-label="breadcrumbs">
					<!-- TemplateBeginEditable name="breadcrumbs" -->
					<ol>
						<li><a href="https://www.unl.edu/">Nebraska</a></li>
						<li><a href="/">TCAN / VITA Lincoln</a></li>
						<li><span aria-current="page">Facilitated Self-Assistance</span></li>
					</ol>
					<!-- TemplateEndEditable -->
				</nav>
			</div>
			<header class="dcf-page-title" id="dcf-page-title">
				<!-- TemplateBeginEditable name="pagetitle" -->
				<h1>Facilitated Self-Assistance</h1>
				<!-- TemplateEndEditable -->
			</header>
			<!-- TemplateBeginEditable name="herogroup1" -->
			<!-- TemplateEndEditable -->
		</div>
		<!-- TemplateBeginEditable name="herogroup2" -->
		<div class="dcf-hero-group-2">
		</div>
		<!-- TemplateEndEditable -->
	</div>
	<div class="dcf-main-content dcf-wrapper">
		<!-- TemplateBeginEditable name="maincontentarea" -->
		<div class="dcf-bleed">
			<div class="dcf-wrapper dcf-pb-8">
				<p>
          The Facilitated Self Assistance is a (Self Prepared) tax return process. To use this service there are income restrictions to meet to qualify for the free use of this service. If your household makes less than $84,000 and you would like to file your own return, we can provide you free access to TaxSlayer, on online tax software, to file your federal and state returns yourself at no cost. Due to software restrictions, we cannot post these links publicly. If you'd like to use this service, please fill out the form below. After signing up, you'll receive an email with secure access instructions for TaxSlayer. Access begins February 1 of each tax season.
        </p>
        <p>
          To sign up for this service please sign up here: <a href="https://tcan.unl.edu/facilitated-self-assistance-fsa-tax-filing-program-signup/" target="_blank">https://tcan.unl.edu/facilitated-self-assistance-fsa-tax-filing-program-signup/</a>.
				</p>
			</div>
		</div>
		<!-- TemplateEndEditable -->
	</div>
